import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatSelect } from '@angular/material/select';

import { MatOption } from '@angular/material/core';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-nouveau-organisme-gestionnaire',
    templateUrl: './modal-nouveau-organisme-gestionnaire.component.html',
    styleUrls: ['./modal-nouveau-organisme-gestionnaire.component.scss'],
    imports: [CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatSelect, MatOption, MatDialogActions, MatButton, MatDialogClose, TranslateModule]
})
export class ModalNouveauOrganismeGestionnaireComponent implements OnInit {
    data = inject(MAT_DIALOG_DATA);

    public form: FormGroup = new FormGroup({
        type: new FormControl<string>(null, [Validators.required]),
        libelle: new FormControl<string>(null, [Validators.required]),
        acronyme: new FormControl<string>(null),
        ville: new FormControl<string>(null, [Validators.required]),
    });

    constructor() {}

    ngOnInit() {}
}
